export const buildApiResourceUrl = (resourcePath) => {
  if (!resourcePath) {
    return "";
  }

  let cleanPath = decodeURIComponent(String(resourcePath).trim());
  if (cleanPath.startsWith("http://") || cleanPath.startsWith("https://")) {
    return cleanPath;
  }

  cleanPath = cleanPath.replace(/^\/+/u, "");
  if (cleanPath.startsWith("storage/empresa/")) {
    cleanPath = cleanPath.replace(/^storage\/empresa\//u, "company-logo/empresa/");
  }

  const resourceBaseUrl = String(process.env.VUE_APP_API_URL_RESOURCE || "").trim();
  if (!resourceBaseUrl) {
    return `/${cleanPath}`;
  }

  const base = resourceBaseUrl.endsWith("/") ? resourceBaseUrl : `${resourceBaseUrl}/`;
  return `${base}${cleanPath}`;
};
